// tslint:disable-next-line:no-any
export default function normalizeListing(data: any) {
  const {state, ...rest} = data;
  return {status: state, ...rest};
}



// WEBPACK FOOTER //
// ./src/models/airbnbAuthModel/utils/normalizeListing.ts